import React, { Component } from 'react';
import { Divider, InputGroup, Button, Intent, FormGroup, NumericInput, Switch } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class ItemEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemName: 'ITEM_EU_W_STAFF_11_SET_B_RARE',
      plusLevel: 11,
      strBonus: 7,
      intBonus: 7,
      targetPlayer: 'Nozich',
      saved: false
    };
  }

  handleSave = (e) => {
    e.preventDefault();
    this.setState({ saved: true });
    setTimeout(() => this.setState({ saved: false }), 3000);
  };

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Item Editor & Inventory Injector
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Modify equipment attributes, plus levels, blue stats, and inject items directly into player inventory.
        </p>

        <Divider className="mb-4" />

        {this.state.saved && (
          <div className="alert alert-success py-2 mb-4" style={{ fontSize: '0.85rem' }}>
            Item attributes updated and injected into {this.state.targetPlayer}'s inventory!
          </div>
        )}

        <form onSubmit={this.handleSave}>
          <div className="row mb-3">
            <div className="col-md-6">
              <FormGroup label="Item Code Name / ID" labelFor="item-name">
                <InputGroup
                  id="item-name"
                  value={this.state.itemName}
                  onChange={(e) => this.setState({ itemName: e.target.value })}
                />
              </FormGroup>
            </div>

            <div className="col-md-6">
              <FormGroup label="Target Player Character" labelFor="target-player">
                <InputGroup
                  id="target-player"
                  value={this.state.targetPlayer}
                  onChange={(e) => this.setState({ targetPlayer: e.target.value })}
                />
              </FormGroup>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-4">
              <FormGroup label="Plus Level (+)">
                <NumericInput
                  min={0}
                  max={20}
                  value={this.state.plusLevel}
                  onValueChange={(val) => this.setState({ plusLevel: val })}
                  fill
                />
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup label="STR Stat Bonus">
                <NumericInput
                  min={0}
                  max={15}
                  value={this.state.strBonus}
                  onValueChange={(val) => this.setState({ strBonus: val })}
                  fill
                />
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup label="INT Stat Bonus">
                <NumericInput
                  min={0}
                  max={15}
                  value={this.state.intBonus}
                  onValueChange={(val) => this.setState({ intBonus: val })}
                  fill
                />
              </FormGroup>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-md-6">
              <Switch label="Bind to Character (Untradeable)" defaultChecked />
              <Switch label="Immortal Protection Active (+11 Guard)" defaultChecked />
            </div>
            <div className="col-md-6">
              <Switch label="Astral Protection Active" defaultChecked />
              <Switch label="Apply Golden Glow Aura Effect" defaultChecked />
            </div>
          </div>

          <Button intent={Intent.PRIMARY} type="submit" icon="edit" small text="Save & Inject Item to Character" />
        </form>
      </SideMenuWrapper>
    );
  }
}
